import React from "react";
import ThemeCustomizer from "./theme/ThemeCustomizer";
import BusinessProfile from "./user-profile/BusinessProfile";
import UserProfile from "./user-profile/UserProfile";
import { ProfileData, Theme } from "./types/profile";
import Configuration from "./Configuration";
import useConfigration from "src/business-types/grocery/hooks/useConfigration";
import PrintConfig from "src/business-types/grocery/layouts/profile/PrintConfig";

interface ProfileTabContentProps {
  activeTab: string;
  profileData: ProfileData | null;
  theme: Theme | null;
  loading: boolean;
  businessType: string;
  onEditBusiness: () => void;
  onEditUser: () => void;
  onUpdateTheme: (theme: Theme) => Promise<{ success: boolean }>;
  onResetTheme: () => Promise<{ success: boolean }>;
}

const ProfileTabContent: React.FC<ProfileTabContentProps> = ({
  activeTab,
  profileData,
  loading,
  theme,
  businessType,
  onEditBusiness,
  onEditUser,
  onUpdateTheme,
  onResetTheme,
}) => {
  const { config } = useConfigration();

  if (loading) {
    return <div className='text-center p-10 text-gray-600'>Loading profile data...</div>;
  }

  if (!profileData) {
    return <div className='text-center p-10 text-gray-600'>No profile data available.</div>;
  }

  return (
    <div className='h-full w-full overflow-auto'>
      {activeTab === "My Profile" && <UserProfile profileData={profileData} onEdit={onEditUser} />}
      {activeTab === "Business Profile" && <BusinessProfile profileData={profileData} businessType={businessType} onEdit={onEditBusiness} />}
      {activeTab === "Theme" && (
        <ThemeCustomizer
          theme={theme}
          businessName={profileData.business_name}
          logo={profileData.logo}
          userName={profileData.user_name}
          onUpdateTheme={onUpdateTheme}
          onResetTheme={onResetTheme}
        />
      )}
      {activeTab === "Page Configuration" && <Configuration />}
      {/* { id: "printerConfig", label: "Printer Config", icon: "🖨️" } */}
      {activeTab === "Printer Config" && <PrintConfig />}{" "}
    </div>
  );
};

export default ProfileTabContent;
